import { Accordion } from '@chakra-ui/accordion'
import { Button } from '@chakra-ui/react'
import type { FormikProps } from 'formik'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import {
  ImageSettingsAdvanced,
  ImageSettingsDeviceBased,
  ImageSettingsOptimization,
  ImageSettingsSecurity,
} from '../../components/Settings'
import type { SettingsResponse } from '../../interfaces'
import { MainContentHeadingBox } from '../Base/MainContent'
import PermissionGuard from "../../components/PermissionGuard"
import { PermissionsEnum } from '../../../utils'

const ImageSettingsLayout = (
  form: FormikProps<SettingsResponse>,
): React.ReactElement => {
  const { t } = useTranslation()

  const { dirty, submitForm, isSubmitting } = form

  return (
    <>
      <MainContentHeadingBox reverse={true}>
        <PermissionGuard
          permission={PermissionsEnum.SELF_IMAGE_SETTINGS_MANAGE}
        >
          {
            (hasPermission: boolean) => (
              hasPermission ? (
                <Button
                  isLoading={isSubmitting}
                  onClick={() => {
                    void submitForm()
                  }}
                  isDisabled={!dirty}
                >
                  {t('save', 'Save')}
                </Button>
              ) : <></>
            )
          }
        </PermissionGuard>
      </MainContentHeadingBox>
      <Accordion borderColor="#9ea3ad33" allowToggle>
        <ImageSettingsOptimization {...form} />
        <ImageSettingsDeviceBased {...form} />
        <ImageSettingsSecurity {...form} />
        <ImageSettingsAdvanced {...form} />
      </Accordion>
    </>
  )
}

export default ImageSettingsLayout
